import {connect} from '../../app/connect';
import TemplatesTable from './TemplatesTable';

import {
  setDuplicateTemplateIdAction,
  setDeleteTemplateIdAction,
  changeLocationAction,
  setQueryParamsAction,
  showNotificationAction,
  updateTemplateAction
} from '../../app/actions';
import {
  getTemplateCategoriesEntitiesMap,
  getTemplateOrderedList,
  getTemplatesCollectionPagination,
  isTemplatesCollectionDidFetchOnce,
  isTemplatesCollectionLoading,
  getTemplatesCollectionHighlightRowIds,
  getLocationsTreeNodes,
  getIsLocationsTreeLoading,
  getIsLocationsLoadingError,
  getProjectId,
  getAnalyticsId,
  getAllOxygenMappings,
  getCurrentUserInMcFormat,
  getIssueRootCausesDefinitionsEntitiesMap,
  getIssueAttributeDefinitionsWhichAreMappedToIssueTypes,
  getTemplatesQueryParams,
  isTemplateCategoriesCollectionLoading,
  getIssueTypesAdminEntitiesMap
} from '../../app/selectors';

const mapStateToProps = state => ({
  templateCategoriesEntitiesMap: getTemplateCategoriesEntitiesMap(state),
  tableData: getTemplateOrderedList(state),
  pagination: getTemplatesCollectionPagination(state),
  didFetchOnce: isTemplatesCollectionDidFetchOnce(state),
  loading: isTemplatesCollectionLoading(state),
  highlightRowIds: getTemplatesCollectionHighlightRowIds(state),
  locationsTreeNodes: getLocationsTreeNodes(state),
  isLocationsTreeLoading: getIsLocationsTreeLoading(state),
  isLocationsLoadingError: getIsLocationsLoadingError(state),
  projectId: getProjectId(state),
  analyticsId: getAnalyticsId(state),
  oxygen: getAllOxygenMappings(state),
  currentUser: getCurrentUserInMcFormat(state),
  rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state),
  customAttributes: getIssueAttributeDefinitionsWhichAreMappedToIssueTypes(state),
  queryParams: getTemplatesQueryParams(state),
  isTemplateCategoriesCollectionLoading: isTemplateCategoriesCollectionLoading(state),
  issueTypeAdminEntitiesMap: getIssueTypesAdminEntitiesMap(state)
});

const mapDispatchToProps = {
  setDuplicateTemplateIdAction,
  setDeleteTemplateIdAction,
  changeLocationAction,
  setQueryParamsAction,
  showNotificationAction,
  updateTemplateAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesTable);
